import '@mdi/font/css/materialdesignicons.css' // Ensure you are using css-loader
import Vue from 'vue'
import Vuetify from 'vuetify/lib'

Vue.use(Vuetify)

export default new Vuetify({
  theme: {
    dark: false,
    themes: {
      light: {
        primary: "#0f4c75",
        secondary: "#DDDDDD",
        accent: "#bbe1fa",
        error: "#cf2115",
        warning: "#ff9800",
        info: "#bbe1fa",
        success: "#4caf50"
      },
      dark: {
        primary: "#555555",
        secondary: "#333333",
        accent: "#9c27b0",
        error: "#cf2115",
        warning: "#ff9800",
        info: "#ffeb3b",
        success: "#4caf50"
      }
    },
    options: {
      customProperties: true
    }
  },
  icons: {
    iconfont: "mdi" // default - only for display purposes
  }
});
